import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./components/ThemeProvider";
import MDXWrapper from "./components/MDXProvider";
import Index from "./pages/Index";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Solutions from "./pages/Solutions";
import Enterprise from "./pages/Enterprise";
import Documentation from "./pages/Documentation";
import About from "./pages/About";
import BookDemo from "./pages/BookDemo";
import NotFound from "./pages/NotFound";
import { useState } from "react";
import "./styles/mdx.css";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Fulfillment from "./pages/Fulfillment";
import Cookies from "./pages/Cookies";
import Security from "./pages/Security";
import Careers from "./pages/Careers";
import FineTuning from "./pages/FineTuning";
import OpenSourceRL from "./pages/OpenSourceRL";
import News from "./pages/News";
import { PostHogAnalyticsProvider } from "./integrations/PostHogAnalyticsProvider";
import { TicTacToeDemo } from "./demos/TicTacToe";
import DemoList from "./pages/DemoList";

const App = () => {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <PostHogAnalyticsProvider>
        <ThemeProvider defaultTheme="system" storageKey="app-theme">
          <TooltipProvider>
            <MDXWrapper>
              <Toaster />
              <Sonner />
              <BrowserRouter>
                <div className="flex flex-col min-h-screen">
                  <div className="flex-grow">
                    <Routes>
                      <Route path="/" element={<Index />} />
                      <Route path="/solutions" element={<Solutions />} />
                      <Route path="/blog" element={<Blog />} />
                      <Route path="/blog/:postId" element={<BlogPost />} />
                      <Route path="/demos" element={<DemoList />} />
                      <Route
                        path="/demos/tic-tac-toe"
                        element={<TicTacToeDemo />}
                      />
                      <Route path="/enterprise" element={<Enterprise />} />
                      <Route
                        path="/documentation"
                        element={<Documentation />}
                      />
                      <Route path="/about" element={<About />} />
                      <Route path="/book-demo" element={<BookDemo />} />
                      <Route path="/news" element={<News />} />

                      <Route path="/fine-tuning" element={<FineTuning />} />
                      <Route
                        path="/open-source-rl"
                        element={<OpenSourceRL />}
                      />

                      <Route path="/terms" element={<Terms />} />
                      <Route path="/privacy" element={<Privacy />} />
                      <Route path="/fulfillment" element={<Fulfillment />} />
                      <Route path="/cookies" element={<Cookies />} />
                      <Route path="/security" element={<Security />} />
                      <Route path="/careers" element={<Careers />} />

                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </div>
                </div>
              </BrowserRouter>
            </MDXWrapper>
          </TooltipProvider>
        </ThemeProvider>
      </PostHogAnalyticsProvider>
    </QueryClientProvider>
  );
};

export default App;
